// @flow
/* eslint-disable no-useless-escape */
import { getLogger } from '@jitsi/logger';
import { setPassword } from '../../../react/features/base/conference/actions';
import { translate } from '../../../react/features/base/i18n/functions';
import { JitsiConferenceEvents } from '../../../react/features/base/lib-jitsi-meet';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { hideWildixModal } from '../../components/base/modal/actions';


import PopupOverlay from './PopupOverlay';

const logger = getLogger(__filename);

type Props = {

    /**
     * Invoked to obtain translated strings.
     */
    t: Function,
    hideWildixModal: Function,
    roomToken: ?string,

    /**
     * The conference name.
     */
    callDisplayName: String,

    /**
     * The {@code JitsiConference} for the current conference.
     */
    conference: Object,

    /**
     * The redux store's {@code dispatch} function.
     */
    dispatch: Dispatch<any>,
};

type State = {
    passwordTextInfo: String,
    passwordValue: String
};

class PopupPassword extends PureComponent<Props> {

    state: State = {
        passwordTextInfo: null,
        passwordValue: null
    };

    constructor(props: Props) {
        super(props);
        this.inputRef = React.createRef();

        this.addEvents();
    }

    /**
     * Implements React's {@link Component#componentDidUnmount()}.
     *
     * @inheritdoc
     */
    componentDidMount() {
        this.inputRef.current.focus();
    }

    /**
     *
     */
    addEvents() {
        const getConference = APP.conference.__getJitsiConference();

        getConference.addEventListener(JitsiConferenceEvents.CONFERENCE_JOINED, () => {
            this.props.hideWildixModal();
            logger.log('Joined with password');
        });
        getConference.addEventListener(JitsiConferenceEvents.CONFERENCE_FAILED, () => {
            this.setState({
                passwordTextInfo: this.props.t('password.errorPasswordWrong')
            });
            logger.error('Wrong password');
        });
    }

    /**
     *
     */
    initConference = password => {
        const { conference } = this.props;

        this.props.dispatch(setPassword(conference, conference.join, password));
    };

    /**
     *
     */
    handleChange = event => {
        event.preventDefault();
        const { value } = event.target;

        this.setState({
            passwordTextInfo: null,
            passwordValue: value
        });
    };

    /**
     *
     */
    handleSubmit = event => {
        event.preventDefault();

        this.initConference(this.state.passwordValue);
    };

    render() {
        const { t } = this.props;
        const { passwordTextInfo } = this.state;

        return (
            <PopupOverlay className={'popup__password popup_opacity_8'}>
                <h2 className={'popup__title'}>
                    {this.props.callDisplayName}
                </h2>
                <p className={'popup__title-small text-center'}>
                    {t('password.titleInfo')}
                </p>

                <form onSubmit={this.handleSubmit}>
                    <div className="popup-auth__item">
                        <input onChange={this.handleChange}
                            className={passwordTextInfo ? 'input__error' : null}
                            name="password"
                            autoComplete={'off'}
                            ref = { this.inputRef }
                            type="text" placeholder={t('password.placeholder')}/>
                        {passwordTextInfo && <span className='input__error-text'>{passwordTextInfo}</span>}
                    </div>
                    <button className={'btn btn_full btn_yellow'} type={'submit'}>
                        {t('button.join')}
                    </button>
                </form>
            </PopupOverlay>
        );
    }
}

function _mapStateToProps(state) {
    const { callDisplayName, roomToken } = state['features/base/config'];

    return {
        callDisplayName,
        roomToken
    };
}

function _mapDispatchToProps(dispatch) {
    return {
        hideWildixModal: () => dispatch(hideWildixModal())
    };
}

export default translate(connect(_mapStateToProps, _mapDispatchToProps)(PopupPassword));
